/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { Button, Col, Layout } from "antd";
import { useLeadCapture } from "../../components/lead-capture";
import { SHORTED_LOGO_URL } from "../../constants/branding";
import IsMobileView from "../../components/utils/mobileView";

const { Content } = Layout;

const LANDING_MAX = 1120;

const defaultBack = { to: "/", label: "← Home" };

/**
 * Shared chrome for public demo routes (no auth).
 */
const DemoLayout = ({ backLink = defaultBack, children }) => {
  const isMobileView = IsMobileView();
  const openLeadCapture = useLeadCapture();
  return (
    <Layout
      className="vc-dashboard vc-landing"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "var(--vc-bg)",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid var(--vc-border)",
          background: "var(--vc-bg-panel)",
        }}
      >
        <div
          style={{
            maxWidth: LANDING_MAX,
            margin: "0 auto",
            padding: "0 16px 0 24px",
            minHeight: isMobileView ? 52 : 56,
            display: "grid",
            gridTemplateColumns: "auto 1fr auto",
            alignItems: "center",
            columnGap: 12,
          }}
        >
          <Link to={backLink.to} style={{ lineHeight: "32px" }}>
            {backLink.label}
          </Link>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 0,
            }}
            aria-label="Shorted home"
          >
            <img
              src={SHORTED_LOGO_URL}
              alt=""
              width={140}
              height={54}
              style={{
                width: isMobileView ? 108 : 132,
                height: "auto",
                maxHeight: isMobileView ? 36 : 42,
                objectFit: "contain",
              }}
            />
          </Link>
          <div
            style={{
              display: "flex",
              gap: 8,
              justifyContent: "flex-end",
              flexWrap: "wrap",
            }}
          >
            <Link to={{ pathname: "/", hash: "login" }}>
              <Button type="default" size="small">
                Sign in
              </Button>
            </Link>
            <Button
              type="primary"
              size="small"
              onClick={() => openLeadCapture()}
            >
              Request Access
            </Button>
          </div>
        </div>
      </div>

      <Content style={{ flex: 1, padding: "0 24px 24px" }}>{children}</Content>

      <Layout className="vc-footer">
        <Col
          md={{ span: 24 }}
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: LANDING_MAX,
            margin: "0 auto",
            width: "100%",
            padding: 24,
          }}
        >
          <p>
            © SHORTED 2026. All Rights Reserved.
            <br />
            <a href="https://shorted.in/terms-conditions/">
              Terms and Conditions
            </a>{" "}
            • <a href="https://shorted.in/privacy-policy/">Privacy Policy</a>
          </p>
        </Col>
      </Layout>
    </Layout>
  );
};

export default DemoLayout;
